




























































import { Component, Vue } from "vue-property-decorator";
import { Col, Row, Tag, List, Image, Field, Button, Popup, Toast } from 'vant';
import { getQueryParam } from "@/utils/index";
import { ErrorCode, ErrorInfo, RequestState } from "@/network/http";
import { formatMessage } from "@/locale";
import { DiscussTopicInfo, DiscussAnswerInfo, DiscussAnswerList } from  "@/data/local/discuss";
import DiscussAnswerItem from "@/components/DiscussAnswerItem.vue";
import PageLoad from "@/components/PageLoad.vue";

Vue.use(Col);
Vue.use(Row);
Vue.use(Tag);
Vue.use(List);
Vue.use(Image);
Vue.use(Field);
Vue.use(Button);
Vue.use(Popup);
Vue.use(Toast);

@Component({
    components: {
        "v-discuss-answer-item": DiscussAnswerItem,
        "v-page-load": PageLoad
    }
})
export default class ForumAnswer extends Vue {
    pageNo: number = 1;
    pageSize: number = process.env.VUE_APP_DEFAULT_PAGE_SIZE;
    immCheck: boolean = false;
    listLoading: boolean = false;
    listFinished: boolean = false;
    listLoadError: boolean = false;
    listLoadingText: string = formatMessage({id: "message.common.loading"});
    finishText: string = formatMessage({id: "message.common.listNoMore"});
    listErrorText: string = formatMessage({id: "message.common.listError"});

    requestState: RequestState = RequestState.WAIT;
    showLoadingPage: boolean = true;

    listData: DiscussAnswerInfo[] = [];
    topicInfo: DiscussTopicInfo = {};
    topicId: number = 0;
    totalAnswer: number = 0;
    replyMsg: string = "";
    showReplyLayout: boolean = false;
    replyLoading: boolean = false;
    
    visitorAvator: string = "http://res.bchun.com/wp-content/uploads/2020/03/visitor-avator.png";
    adminAvator: string = "http://res.bchun.com/wp-content/uploads/2020/03/admin-avator.png";

    mounted() {
        let topicId: number = parseInt(this.$route.params.topicId);
        this.topicId = topicId;

        this.fetchDetail(topicId);
        this.initAnswer();
    }

    get status(): RequestState {
        if (this.requestState === RequestState.WAIT) {
            return RequestState.WAIT;
        } else if (this.requestState === RequestState.FAIL) {
            return RequestState.FAIL;
        } else {
            return RequestState.SUCCESS;
        }
    }

    onRefresh(ret: boolean): void {
        this.showLoadingPage = true;
        this.requestState = RequestState.WAIT;
        this.fetchDetail(this.topicId);
        this.initAnswer();
    }

    get cat(): string {
        if (this.topicInfo.cat === 1) {
            return "贷款业务";
        } else if (this.topicInfo.cat === 2) {
            return "提取业务";
        } else if (this.topicInfo.cat === 3) {
            return "缴存业务";
        } else {
            return "其他业务"
        }
    }

    get avator(): string {
        if (!this.topicInfo.avatorUrl || this.topicInfo.avatorUrl === "") {
            return this.visitorAvator;
        }

        return this.topicInfo.avatorUrl;
    }

    initAnswer() {
        this.listData = [];
        this.pageNo = 1;
        this.fetchList();
    }

    fetchDetail(topicId: number): void {
        let lThis:any = this;
        lThis.$http.getDiscussDetail(topicId, (errorInfo: ErrorInfo, data: DiscussTopicInfo | null) => {
            if (errorInfo.errorCode !== ErrorCode.SUCCESS) {
                this.requestState = RequestState.FAIL;
            } else {
                this.requestState = RequestState.SUCCESS;
                this.topicInfo = data;
            }

            this.showLoadingPage = false;
        });
    }

    fetchList(): void {
        this.listLoading = true;
        this.listLoadError = false;
        this.listFinished = false;

        let lThis:any = this;
        lThis.$http.getDiscussAnswerList(this.topicId, this.pageNo, this.pageSize, (errorInfo: ErrorInfo, data: DiscussAnswerList) => {
            if (errorInfo.errorCode !== ErrorCode.SUCCESS) {
                this.listLoadError = true;
            } else {
                this.totalAnswer = data.pagination.totalCount;

                data && data.list.forEach((item: DiscussAnswerInfo) => {
                    // 去重 
                    let exist: boolean = false;
                    for (let n = 0; n < this.listData.length; n++) {
                        if (this.listData[n].id === item.id) {
                            exist = true;
                            break;
                        }
                    }

                    if (!exist) {
                        this.listData.push(item);
                    }
                });

                this.pageNo = this.pageNo + 1;

                if (data && this.pageNo > data.pagination.totalPage) {
                    this.listFinished = true;
                }
            }

            this.listLoading = false;
        });
    }

    onReply() {
        this.showReplyLayout = true;
    }

    onSubmitReply() {
        this.replyLoading = true;

        if (!this.replyMsg || this.replyMsg === "") {
            Toast("请输入内容！");
            this.replyLoading = false;
            return;
        }

        let lThis:any = this;
        lThis.$http.replyTopic(this.topicId, this.replyMsg, (errorInfo: ErrorInfo) => {
            if (errorInfo.errorCode !== ErrorCode.SUCCESS) {
                this.replyLoading = false;
                Toast(errorInfo.msg);
            } else {
                Toast("答复成功!");
                this.showReplyLayout = false;
                this.replyLoading = false;
                this.replyMsg = "";
                this.initAnswer();
            }
        });
    }
}
